import { useEffect, useState } from "react";

import GroupService from "../../Services/Licenses/GroupService";

export default function useGroups() {
    const [groups, setGroups] = useState([])

    useEffect(() => {
        GroupService.getGroups().then(data => data && setGroups(data))
    }, [])

    return groups
}
